"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Airport Transportation",
  description: "Reliable airport transportation designed to keep arrivals and departures smooth, organized, and stress-free with proactive communication, flight monitoring, and early chauffeur arrivals.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chatgpt_chevrolet_suburban_suv.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-Jun-26-2026-01_34_57-AM.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-Jun-26-2026-01_34_57-AM.png",
    alt: "Luxury SUV at the airport tarmac"
  }
}, {
  title: "Corporate Events, Parties & Conventions",
  description: "Professional chauffeur service that keeps corporate transportation punctual, organized, and easy to coordinate throughout conferences, conventions, and company events across Los Angeles.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-Jun-26-2026-01_38_44-AM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-Jun-26-2026-01_38_44-AM.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-Jun-26-2026-01_38_44-AM.png",
    alt: "Los Angeles downtown skyline at dusk"
  }
}, {
  title: "VIP Car Service",
  description: "Discreet luxury transportation for executives, VIPs, and important guests who expect professionalism, privacy, and smooth coordination throughout busy schedules.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/service_vip_car.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/service_vip_car.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/service_vip_car.png-wvc-sizes",
    alt: "Executive working in the back of a luxury car"
  }
}, {
  title: "Hourly Chauffeur Services",
  description: "Flexible chauffeur service for changing schedules, multiple stops, and full-day transportation throughout Los Angeles with smooth, responsive coordination throughout the day.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-06_11_14-PM.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/premium_suv_fleet.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/premium_suv_fleet.png",
    alt: "Interior view of a luxury sprinter van"
  }
}, {
  title: "Wedding Transportation",
  description: "Professional wedding transportation designed to keep ceremonies, receptions, bridal parties, and guest transportation organized, comfortable, and stress-free.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/limo.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/limo.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/limo.png",
    alt: "Bridal bouquet and wedding dress detail"
  }
}, {
  title: "Prom Transportation",
  description: "Safe and professionally coordinated prom transportation focused on reliability, punctual arrivals, and helping the night feel smooth and memorable.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/Screenshot-2026-02-17-133500.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-06_11_14-PM.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-06_11_14-PM.png",
    alt: "Close up of a prom corsage on a wrist"
  }
}, {
  title: "Bachelor & Bachelorette Parties",
  description: "Flexible group transportation for nightlife and celebrations that helps keep the night organized, comfortable, and easy to coordinate throughout multiple stops.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/service_bachelor_party.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/service_bachelor_party.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/service_bachelor_party.webp-wvc-sizes",
    alt: "Group of friends celebrating in a limousine"
  }
}, {
  title: "Nights Out & Milestone Celebrations",
  description: "Luxury transportation for birthdays, concerts, anniversaries, and special occasions designed to keep the experience smooth, comfortable, and easy to enjoy.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/professional_chauffeur_service.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-06_11_14-PM.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/ChatGPT-Image-May-5-2026-06_11_14-PM.png",
    alt: "Friends enjoying a night out celebration"
  }
}];
export default function ServiceGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="servicegrid" className="section-padding !text-[hsl(210,17%,98%)] !bg-[hsl(24,10%,25%)]">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl font-display font-bold tracking-tight !text-[hsl(0,0%,100%)] md:text-4xl lg:text-5xl">
            Our Services
          </h2>
        </div>

        <div ref={ref} className={`flex overflow-x-auto pb-8 gap-6 snap-x scrollbar-hide transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {services.map((service, index) => <Card key={index} data-index={index} className="min-w-[280px] md:min-w-[320px] snap-start bg-white/60 backdrop-blur-md border border-white/40 rounded-sm shadow-soft hover:shadow-medium hover:-translate-y-1 transition-all duration-300 flex flex-col overflow-hidden">
              <div className="relative h-48 w-full overflow-hidden">
                <img src={service.image.src} data-wvc-srcset={service.image.srcset} data-wvc-sizes={service.image.sizes} alt={service.image.alt} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" loading="lazy" />
              </div>
              <CardContent className="p-6 flex flex-col flex-grow !bg-[hsl(0,0%,15%)]">
                <h3 className="font-display font-bold text-lg mb-3 leading-tight !text-[hsl(41,96%,60%)]">
                  {service.title}
                </h3>
                <p className="font-sans text-sm text-white/70 mb-6 flex-grow leading-relaxed">
                  {service.description}
                </p>
                <div className="mt-auto pt-2">
                  <Button variant="link" asChild className="p-0 h-auto text-primary font-semibold hover:text-primary-hover hover:no-underline justify-start group">
                    <Link to="/ServicesPage">
                      Learn More 
                      <ArrowRight className="ml-1.5 w-4 h-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}